import { FC } from 'react';

import { Typography, useTheme } from '@mui/material';

import MainCard from 'src/components/MainCard/MainCard';

interface OffersContainerProps {
    title: string;
    children: React.ReactNode;
}

const OffersContainer: FC<OffersContainerProps> = ({ title, children }) => {
    const theme = useTheme();
    return (
        <MainCard boxShadow={theme.shadows[2]}>
            <Typography fontWeight={500} fontSize="20px" color={theme.palette.grey[800]} mb="16px">
                {title}
            </Typography>
            {children}
        </MainCard>
    );
};

export default OffersContainer;
